import debug from 'debug';
const log = debug('moveo:upload-file');
export async function uploadFile(url, file, maxRetries = 3) {
    let attempts = 0;
    while (attempts < maxRetries) {
        try {
            attempts++;
            const response = await fetch(url, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type,
                },
            });
            if (!response.ok) {
                throw new Error(`Upload failed with status ${response.status}: ${response.statusText}`);
            }
            return JSON.stringify({
                message: 'success',
                text: url,
            });
        }
        catch (error) {
            log(`Attempt ${attempts} failed:`, error);
            if (attempts >= maxRetries) {
                log('Max retries reached. Upload failed.');
                return JSON.stringify({ message: 'error' });
            }
            // wait 1s before retrying
            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }
    return JSON.stringify({ message: 'error' });
}
